module.exports = __webpack_public_path__ + "static/UnclickMedicalTravel-1aefef9aaf37537c24201ffd240d96c9.png";